/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SerieViewModel } from "../types/SerieViewModel.ts";
import { serieClassStudentItemViewModelSchema } from "./serieClassStudentItemViewModelSchema.ts";

export const serieViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da série.")),
  companyId: z
    .number()
    .int()
    .describe(
      "ID da empresa associada. Nulo quando é geral (do sistema). Opcional.",
    )
    .nullish(),
  title: z.string().describe("Título da série no idioma corrente.").nullish(),
  resumee: z
    .string()
    .describe("Resumo/descrição da série no idioma corrente.")
    .nullish(),
  thumbnail: z
    .string()
    .describe("Caminho da imagem de capa no storage. Opcional.")
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se a série está ativa.")),
  isGeneral: z.optional(
    z
      .boolean()
      .describe("Indica se a série é geral (disponível a todas as turmas)."),
  ),
  classStudents: z
    .array(z.lazy(() => serieClassStudentItemViewModelSchema))
    .describe("Turmas vinculadas (quando a série não é geral).")
    .nullish(),
}) as unknown as ToZod<SerieViewModel>;
